module.exports = __webpack_public_path__ + "static/media/oberflex-tineo-1200x2490.05dfa19e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-tineo-1200x2490.jpg
// module id = 1060
// module chunks = 37